import { render } from "./KOLPerformance.vue?vue&type=template&id=62a7f120"
import script from "./KOLPerformance.vue?vue&type=script&lang=js"
export * from "./KOLPerformance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__